import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { postPackWidget, deletePackWidget } from '../actions';
import Checkbox from 'material-ui/Checkbox';

class WidgetCell extends Component {
    shouldComponentUpdate(nextProps) {
        if (this.props.isDisplay !== nextProps.isDisplay) {
            return true;
        }

        return false;
    }

    render() {
        const { widget = {}, isChecked = false, isDisplay = true, postPackWidget, deletePackWidget } = this.props;

        return (
            <li>
                <Checkbox
                    type="checkbox"
                    label={widget.name}
                    onCheck={(e, isChecked) => {
                        isChecked ? postPackWidget(widget.id) : deletePackWidget(widget.id);
                    }}
                    defaultChecked={isChecked}
                    disabled={!isDisplay}
                />
            </li>
        );
    }
}

WidgetCell.propTypes = {
    widget: PropTypes.object.isRequired,
    isChecked: PropTypes.bool,
    // From connect
    isDisplay: PropTypes.bool,
    postPackWidget: PropTypes.func.isRequired,
    deletePackWidget: PropTypes.func.isRequired
};

export default connect(
    ({ packs }, { widget }) => {
        const filterWidgetsText = packs.filterWidgetsText;

        return {
            isDisplay: filterWidgetsText
                ? widget.name.toLowerCase().indexOf(filterWidgetsText.toLowerCase()) !== -1
                : true
        };
    },
    { postPackWidget, deletePackWidget }
)(WidgetCell);



/** WEBPACK FOOTER **
 ** ../src/dash/front/packs/components/WidgetCell.js
 **/